/*
 * Media guard: makes saving the storefront's images and videos a deliberate
 * act instead of a right-click. A deterrent, not DRM; anything the browser can
 * display can still be pulled from the network panel or a screenshot.
 *
 * Right-click is checked against everything stacked under the pointer, because
 * the theme lays gradients and click targets over its photography, and a
 * contextmenu on the overlay would otherwise reach the picture beneath it.
 */
(function () {
  var MEDIA = 'img, picture, video, canvas, source';
  var FIELD = 'input, textarea, select, [contenteditable=""], [contenteditable="true"]';

  function isMedia(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.matches(MEDIA)) return true;
    var bg = getComputedStyle(el).backgroundImage;
    return !!bg && bg !== 'none' && bg.indexOf('url(') !== -1;
  }

  function overMedia(e) {
    if (e.target.closest && e.target.closest(FIELD)) return false;
    if (isMedia(e.target)) return true;
    var stack = document.elementsFromPoint ? document.elementsFromPoint(e.clientX, e.clientY) : [];
    for (var i = 0; i < stack.length; i++) {
      if (stack[i].matches && stack[i].matches('a, button, [role="button"]') && !stack[i].querySelector(MEDIA)) {
        // A control with no picture inside it; keep looking underneath only if
        // it is a transparent overlay, otherwise it is genuine text or a label.
        if (stack[i].textContent.trim()) return false;
      }
      if (isMedia(stack[i])) return true;
    }
    return false;
  }

  document.addEventListener('contextmenu', function (e) {
    if (overMedia(e)) e.preventDefault();
  }, true);

  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.matches && e.target.matches(MEDIA)) e.preventDefault();
  }, true);

  function lockVideo(v) {
    v.setAttribute('controlsList', 'nodownload noremoteplayback');
    v.setAttribute('disablePictureInPicture', '');
    v.setAttribute('disableRemotePlayback', '');
    v.setAttribute('draggable', 'false');
  }

  function lockImage(img) {
    img.setAttribute('draggable', 'false');
  }

  function sweep(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('video').forEach(lockVideo);
    root.querySelectorAll('img').forEach(lockImage);
  }

  sweep(document);
  new MutationObserver(function (list) {
    list.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'VIDEO') lockVideo(n);
        else if (n.tagName === 'IMG') lockImage(n);
        else sweep(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
